import React from "react";
import { useDraggable } from "@dnd-kit/core";
import { Box, Typography, Paper } from "@mui/material";
import { FIELD_TYPES } from "../formsUtils";

const CATEGORIES = [
  { key: "entrada", label: "Entrada" },
  { key: "escolha", label: "Escolha" },
  { key: "layout", label: "Layout" },
];

/** Paleta de tipos de campo. Cada item é arrastável e também adiciona ao clicar. */
export default function FieldPalette({ onAdd }) {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>Campos</Typography>
      {CATEGORIES.map((cat) => (
        <Box key={cat.key} sx={{ mb: 2 }}>
          <Typography variant="caption" color="text.secondary">{cat.label}</Typography>
          {FIELD_TYPES.filter((f) => f.category === cat.key).map((ft) => (
            <PaletteItem key={ft.type} fieldType={ft} onAdd={onAdd} />
          ))}
        </Box>
      ))}
    </Box>
  );
}

function PaletteItem({ fieldType, onAdd }) {
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `new-${fieldType.type}`,
    data: { isPalette: true, fieldType: fieldType.type },
  });

  return (
    <Paper
      ref={setNodeRef}
      {...listeners}
      {...attributes}
      onClick={() => onAdd(fieldType.type)}
      elevation={0}
      sx={{
        display: "flex", alignItems: "center", gap: 1, p: 1, my: 0.5,
        border: "1px solid #e0e0e0", borderRadius: 1, cursor: "grab",
        opacity: isDragging ? 0.4 : 1, userSelect: "none",
        "&:hover": { borderColor: "#3f51b5", background: "#f5f6ff" },
      }}
    >
      <i className={fieldType.icon} style={{ width: 18, textAlign: "center", color: "#3f51b5" }} />
      <Typography variant="body2">{fieldType.label}</Typography>
    </Paper>
  );
}
